module.exports = __webpack_public_path__ + "83568f76a0a948ca626f825f1bab7e5f.svg";